import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { cn } from '@/lib/utils';

export function LanguageSelector() {
  const { i18n, t } = useTranslation();

  return (
    <div className="relative group">
      <button
        className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        title={t('settings.language')}
      >
        <Globe className="w-5 h-5 text-gray-600 dark:text-gray-300" />
      </button>

      <div className="absolute right-0 mt-2 w-48 bg-white dark:bg-dark-paper rounded-lg shadow-lg border border-gray-100 dark:border-dark-border py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
        {Object.keys(i18n.options.resources || {}).map((lang) => (
          <button
            key={lang}
            onClick={() => i18n.changeLanguage(lang)}
            className={cn(
              "w-full px-4 py-2 text-left text-sm transition-colors",
              i18n.language === lang
                ? "text-royal-purple bg-royal-purple/5 font-medium"
                : "text-gray-600 dark:text-dark-primary hover:bg-gray-50 dark:hover:bg-dark-elevated"
            )}
          >
            {t(`languages.${lang}`)}
          </button>
        ))}
      </div>
    </div>
  );
}